export default {
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
    login: {
      signUp:'가입하기', 
      title: '모든 디지털 자산을 위한 범용 지갑.',
      submit: '로그인',
      username: '전화번호를 입력하세요',
      password: '비밀번호를 입력하세요',
      verifycode:'보안문자를 입력하세요',
      forget_password:'비밀번호를 잊어 버렸습니까?', 
	  no_account:'AuWallet 계정이 없으신가요?',
      register:'등록하다',
      verifycode_tip:'보안 문자를 입력하십시오',
      verifycode_error:'잘못된 보안 문자'
    },
    register:{
      title:'등록하다',
      username:'전화 번호',
      get_code:'코드 받기',
      verifycode:'확인 코드',
      password:'비밀번호',
      repeat:'확인하다',
      invite_code:'초대 코드',
      submit:'등록하다',
      registered:'이미 계정이 있음',
      go_login:'로그인 이동'
    },
    nologin:{
      cloud_wallet:'클라우드 월렛',
      cloud1:'최고의 보안 보호',
      cloud2:'고유 자산 획득, 코인 등록 및 입금을 통해 수익을 즐기세요',
      cloud3:'30개 이상의 주류 코인 및 500개 이상의 토큰 지원',
      button1:'등록하다',
      button2:'로그인',
      button_oauth: '2U.Chat으로 로그인',
      hd_wallet:'HD 지갑',
      hd1:'개인 키의 100% 제어, 더 확실한 자산',
      hd2:'니모닉 단어의 원 클릭 가져오기, 편리하고 사용하기 쉬운',
      hd3:'30개 이상의 주류 코인 및 500개 이상의 토큰 지원',
      button3:'등록하다',
      button4:'로그인',
      doLogin:"로그인하려면 클릭하세요",
      welcomeTo:"AuWallet에 오신 것을 환영합니다.",
    },
    forget:{
      title:'비밀번호를 잊으 셨나요?',
      phone_number:'전화 번호',
      verify_code:'확인 코드',
      password:'비밀번호',
      repeat:'다시 반복하라',
      submit:'확인하다'
    },
    footer:{
      nav1:'지갑',
      nav2:'시장',
      nav3:'유산',
      nav4:'발견하다',
      nav5:'나의'
    },
    home:{
      total:'총 자산',
      invite:'친구를 초대',
      redbag:'레드 패킷 보내기',
      exchange:'교환',
      scan:'주사',
      address_book:'주소록',
      notice:'공지사항',
      setting:'설정',
      view_mnemonic:'니모닉 보기',
      backup_mnemonic:'백업 니모닉',
      create_wallet:'지갑 생성',
      import_wallet:'지갑 가져오기', 
      welcome:'어서 오십시오',
	  cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
    },
    
    address:{
      new_address:'새 주소',
      name:'이름',
      address:'주소',
      submit:'만들다',
	  warning_msg: '주의: 이 주소는 ERC20 토큰만 받을 수 있습니다. 이체할 때 통로를 잘못 선택하지 않도록 주의하십시오.'
    },
    swap:{
      title:'플래시 스왑',
      pay:'당신은 지불해야 ',
      balance:'사용 가능한 잔액',
      lock_rate:'이 환율을 고정하려면 다음 시간 내에 결제를 완료하세요.',
      gain:'당신은 얻을 것이다',
      input:'금액을 입력해주세요',
      tip:'획득한 통화가 비어 있으면 플래시 스왑할 통화가 없음을 의미합니다.',
      submit:'지금 교환',
      choose_coin:'코인 선택',
	  notice_2ut: '나는 이 공지를 읽었다'
    },
    coin:{
      send:'보내다',
      swap:'교환',
      receive:'받다',
      transactions:'업무',
      type1:'클라우드 아웃',
      type2:'클라우드 인',
      type3: '교환',
      type4:'재무',
      type7:'HD 출력',
      type8:'HD 입력',
      type9:'레드 패킷 보내기',
      type10:'레드 패킷 수락',
	  type11:'AuWallet transfer out TimeEx',
	  type12:'TimeEx transfer in AuWallet',
	  type13: 'Chain shopping service fee',
	  type14: '10% Off shopping service fee',
	  type15: 'Withdrawal',
	  type16: 'KYC Certification fees',
      flushing:'플러싱...',
      loading:'로드 중...',
      no_records:'기록 없음',
      wallet:' 지갑',
      tx_time:'트랜잭션 시간',
      tx_id:'아이디',
      tx_from:'보낸사람',
      tx_to:'받는 사람',
      tx_memo:'비고',
      tx_status1:'실패',
      tx_status2:'대기 중',
      tx_status3:'성공',
      tx_status4:'보류 중',
  
      receive_address:'수신 주소를 입력하세요',
      balance:'균형',
      fee:'회비',
      send_all:'모두 보내기',
      gas_fee:'가스비',
      slow:'느린',
      fast:'빠른',
      send:'보내다',
      tx_password:'결제 비밀번호를 입력하세요',
      tx_remark:'비고(선택사항)',
      address_book1:'클라우드 주소록',
      address_book2:'HD 주소록',
      need_pay_pass:'결제 비밀번호를 먼저 설정하세요',
      need_pin:'개인 센터로 이동하여 핀 코드를 설정하세요',
  
      
      set_receive_amount:'수신 금액 설정',
      receive_amount:'수취 금액',
      copy_receive_code:'결제 코드 복사',
      confirm:'확인하다',
      cancel:'취소',
      rcv_address:'수신 주소',
      search:'검색 내용 입력',
      filter:'필터',
      remove:'제거하다',
      add:'추가하다',
  
      filter1:'모든 통화',
      filter2:'추가됨',
      filter3:'추가되지 않음',
      
      notices:'HD 월렛 공지사항',
      notices2:'클라우드 월렛 공지사항',
	  only_bitcoin: '여기는 비트코인 거래밖에 없어요.',
	  only_eth: 'ETH 거래만',
	  only_usdt: '여기는 USDT ERC20 거래밖에 없어요.',
	  only_2ut: '여기에는 2UT 트랜잭션만 있습니다.',
	  only_u2u: 'U2U 코인 전용',
	  only_2u: '2U 포인트만',
	  only_a2u: 'A2U 전용',
	  import: 'Import',
	  info: 'Token overview'
    },
  
    market:{
      title:'시장',
      coin:'유산',
      volume:'용량',
      price:'가격',
      change:'변경(24시간)',
    },
  
    discover:{
      title:'발견하다',
      popular:'인기있는',
      all:'모두'
    },
  
    my:{
      title:'나의',
      notice:'공지사항',
      login:'로그인하려면 클릭하세요',
      welcome:'AuWallet에 오신 것을 환영합니다',
      invite:'초대 보상',
      news:'데일리 익스프레스',
      contact:'고객 서비스',
      pin_on:'켜기',
      pin_off:'꺼짐',
      default_currency:'기본 통화',
      red_green:'견적 옵션',
      option1: '녹색 위 빨강 아래',
      option2: '빨간색 위 녹색 아래',
      contract:'이용 약관',
      privacy:'개인 정보 정책',
      help:'지원 센터',
		invite: 'My Invite code',
		onequan: 'My Business Circle',
		copy: 'Copy',
		total: 'Total',
		downloadapp: 'Download mobile APP.',
		download: 'Download',
		waiting: 'Waiting Or Use',
		reenxv: 'GreenX Vcode',
		greenxvet: 'Can use'
    },
    setup:{
      title:'지갑 설정',
      pay_password:'결제 비밀번호',
      on:'켜짐',
      off:'끄다',
      google:'구글 인증',
      security_level:'보안 수준',
      account_name:'계정 이름',
      logout:'로그 아웃',
      register_time:'시간 등록',
      level:'수준',
      modify_pay_password:'지불 비밀번호 수정',
      reset_pay_password:'지불 비밀번호 재설정',
      reset_tip:'계정 보안을 위해 본인 확인을 위해 원래 결제 비밀번호를 입력하세요',
      forget_pay_password:'결제 비밀번호 분실',
      set_pay_password:'결제 비밀번호 설정',
      enter_password:'비밀번호를 입력하세요',
      enter_password2:'다시 입력하세요',
      vcode:'인증 코드',
      submit:'확인하다',
      pay_password_wrong:'입력하신 비밀번호가 잘못되었습니다',
      fontSize:'글꼴 크기'
      
    },
    news:{
      title:'데일리 익스프레스',
      share:'공유하다',
      good:'좋은',
      bad:'나쁜',
    },
    pin:{
      title:'PIN 코드 설정',
      desc1:'자산의 보안을 보호하기 위해 먼저 PIN 코드를 설정하십시오. PIN 코드는 지갑 잠금을 해제하고 코인을 보내는 데 사용됩니다',
      desc2:'PIN 코드는 로컬 암호입니다. 올바르게 보관하십시오. 분실하면 복구할 수 없습니다.',
      close:'PIN 코드 끄기',
      title2:'PIN 확인',
      tip2_1:'PIN 코드를 잊어버리셨습니까? 지갑 백업 후 앱 재설치 및 니모닉 문구 불러오기 후 초기화'
    },
    google:{
      title:'Google 확인',
      tip:'Google 2단계 인증은 계정에 보호 계층을 추가할 수 있습니다. 로그인 또는 거래시 비밀번호 입력시 2단계 인증에서 인증코드도 필요합니다',
      help:'Google 2단계 인증 사용 방법',
    },
    security:{
      title:'보안 수준',
      title2:'보안 수준',
      tip: '자금의 안전을 위해 코인을 출금하기 전에 추가 보안 설정과 실명 정보가 필요하며 그에 따라 출금 한도가 증가합니다',
      l3title:'문서 유형 선택',
      l3tip:'인증서 발급 국가를 선택하세요',
      c1:'미국',
      c2:'중국 본토',
      c3:'중국 홍콩, 마카오 및 대만',
      c4:'한국',
      c5:'일본',
      c6: '싱가포르',
      c7:'기타',
      nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
    },
    realname:{
      title:'인증 정보',
      tip:'AuWallet은 보안 확인을 통과하기 위해 정부에서 발행한 사진이 부착된 신분증을 제출해야 합니다.',
      subtitle1:'2U 토큰(2UT) 구독 양식',
      country:'국가',
      country_hint:'귀하의 거주 국가',
      firstname:'이름',
      firstname_hint:'당신의 이름',
      surname:'성',
      surname_hint:'너의 성',
      birthdate:'생일',
      cert_id:'ID 번호',
      cert_id_hint:'귀하의 ID 번호',
      id_photo1:'신분증 앞면 사진',
      id_photo2:'신분증 뒷면 사진',
      address:'주소',
      address_hint:'현재 거주지',
      addr_photo:'주소 증명',
      asset_photo:'자산 증명',
      subtitle2:'투자자자격증',
      tip1:'나는 다음 기준 중 하나 이상을 충족하고 발행사로부터 적격 투자자로 인증되었음을 확인합니다(해당되는 경우 둘 이상 선택할 수 있음)',
      tip2:'주(1): 투자포트폴리오란 부동산을 제외한 증권과 현금을 말합니다.',
      tip3:'참고(2): 월별 명세서, 계산요약서 등이 있는 서류는 최근 3개월 이내의 서류를 첨부해야 함',
      invest_exp:'투자 경험',
      other_exp:'기타',
      avg_volume:'볼륨',
      avg_volume_hint:'지난 12개월 동안의 평균 거래량(USD)',
      avg_num:'숫자',
      avg_num_hint:'지난 12개월 동안의 평균 거래 수',
      exp_year:'투자 연도',
      exp_year_hint:'몇 년의 투자 경험',
      net_asset:'순 자산',
      net_asset_hint:'순 자산 가치(USD)',
      risk_tolerance:'위험 허용 범위',
      invest_term:'이상적인 투자기간',
      derivative:'파생상품',
      signature:'서명',
      reset:'초기화',
      phone_number:'전화번호',
      submit:'제출하다',
      option1_1:'배우자 또는 자녀와 공동 계좌에 US$20,000(또는 이에 상응하는 금액) 이상의 현금 및/또는 증권 포트폴리오를 보유한 개인 또는 고액 순자산 개인 투자자',
      option1_2:'회사 또는 파트너십의 투자 포트폴리오가 US$20,000 이상 또는 총 자산이 US$2백만 이상',
      option1_3: '고순자산 가치의 개인 투자자 또는 회사 또는 파트너십이 De La O RuralBank Inc.에 계좌를 개설하고 이 평가 양식에 서명할 당시 미화 20,000달러 이상 보유',
      option2_1:'증권',
      option2_2:'선물',
      option2_3:'배치',
      option2_4:'기타(명시해 주세요)',
      option3_1:'높음',
      option3_2:'중간',
      option3_3:'낮음',
      option4_1:'3년 이상',
      option4_2:'1-3년',
      option4_3:'1년 미만',
      option5_1:'예',
      option5_2:'아니요'
    },
    envelope:{
      title:'빨간 봉투',
      owned:'내 봉투',
      amount:'양',
      quantity:'수량',
      quantity_hint:'봉투 수량',
      generate:'생성하다',
      title2:'봉투 보내기',
      total:'빨간 봉투 총액',
      wishes:'소원',
      submit:'지불',
      enter_pass:'결제 비밀번호를 입력해주세요',
      choose_path:'배송 방법 선택',
      view:'빨간 봉투 세부 정보 보기',
      choose_coin:'코인 선택',
      need_pay_password:'먼저 결제 비밀번호를 설정하세요.',
      share:'빨간 봉투를 친구들과 공유하세요',
      title3:'빨간 봉투 기록',
      num:'수량',
    },
    mnemonic:{
      title:'백업 지갑 니모닉',
      tip:'니모닉은 자산을 제어하는 키인 개인 키입니다.',
      tip1:'1. 12자로 구성되어 있으므로 복사하여 안전한 곳에 보관하시기 바랍니다.',
      tip2:'2. 100% 귀하가 보관하며, 한 번 분실하면 되찾을 수 없습니다.',
      tip3:'3. 니모닉어구 백업을 완료한 후 화폐를 받거나 제거하시기 바랍니다.',
      backup:'백업 지금',
      later:'나중에 해',
      tip4:'둘러봐주세요',
      tip5:'니모닉을 얻는 사람은 자산을 얻었음을 의미합니다. 주변에 사람이 없고 카메라가 없는지 확인하십시오.',
      understand:'이해했다',     
      title2:'니모닉 보기',
      tip6:'니모닉 문구를 가져와서 다른 기기에서 페어링하거나, 다른 기기에서 AuWallet 지갑을 사용하여 QR 코드를 스캔하여 페어링할 수 있습니다.',
      tip7:'스크린샷을 찍지 마세요! 누군가가 당신의 니모닉 문구를 얻는다면, 그들은 당신의 자산을 직접 얻을 것입니다!',
      view_code:'암호화된 QR 코드 보기',
      tip8:'QR 코드를 암호화하면 지갑이 새 장치와 쉽게 페어링할 수 있습니다. 스크린샷을 찍어서 저장하지 마시고 주변에 다른 사람이나 몰래카메라가 없는지 확인해주세요.',
      tip9:'이 QR 코드는 AU 지갑에서만 사용할 수 있습니다. 스캔 시 해당 니모닉을 성공적으로 가져오려면 가져올 APP에 현재 APP의 PIN 코드를 입력해야 합니다.',
  
      title3:'AuWallet 니모닉을 복사하세요',
      tip3_1:'AuWallet 니모닉 문구는 지갑을 복원하는 데 사용됩니다. 다음 12단어를 종이에 순서대로 복사하여 안전한 곳에 보관하십시오.',
      tip3_2:'스크린샷을 찍지 마세요! 누군가가 당신의 니모닉 문구를 얻는다면, 그들은 당신의 자산을 직접 얻을 것입니다!',
      save:'안전하게 저장했습니다',
  
      title4:'AuWallet 니모닉 문구를 확인하세요',
      tip4_1:'AuWallet 니모닉 단어를 올바르게 복사했는지 확인하려면 일련 번호에 해당하는 단어를 선택하십시오.',
      finish:'마침',
      next:'다음',
      verror:'검증 오류',
  
      title5:'니모닉 지갑 복원',
      tip5_1:'지갑 답장을 위해 아래 양식에 니모닉 단어를 입력해주세요. 각 니모닉 단어를 입력한 후 "스페이스" 키를 눌러 다음 단어로 이동',
      recover:'복구 시작',
      ask:'현재 지갑을 덮어쓰시겠습니까?',
      tip5_2:"지갑을 가져오면 현재 지갑을 덮어씁니다. 아직 백업하지 않았다면 현재 지갑은 영원히 사라집니다.",
      tip5_3:'현재 지갑을 백업하고 덮어쓰기에 동의합니다',
      cancel:'취소',
      import:'가져오기 계속',
      agree:'동의를 선택하세요',
      create_success:'성공적으로 생성됨',
      complete:'완전한 니모닉을 입력하세요',
    },
    invite:{
      title:'내 초대장',
      total:'초대 번호',
      invite_num:'등록된 친구 수',
      bonus1:'1레벨 친구',
      every:'사람마다',
      bonus2:'2레벨 친구',
      bonus3:'3레벨 친구',
      deposit:'코인을 입금한 친구 수',
      list:'초대 목록',
      subtitle1:'등록',
      subtitle2:'보증금',
      no_records:'아직 초대장이 없습니다.'
    },
    lang:{
      set_lang:'언어 설정',

    },
    setting:{
      tip:"시스템은 실제로 미국 달러로 거래되며 시스템은 사용자의 수수료 가격을 최신 환율에 따라 자동으로 미국 달러로 변환합니다. 실제 수수료 가격은 사용자가 입력한 가격과 약간 다를 수 있습니다."
    },
    send:{
      title:'전송 유형',
      t1:'블록체인 전송',
      t2:'내부 거래',
    },
    sortable:{
      title:'사용자 정의 정렬',
      drag_to_sort:'드래그하여 정렬',
      currency:'통화'
    },
    system:{
      flushing:'홍조...',
      loading:'로딩 중...',
      btn1:'확인하다',
      btn2:'취소',
      add:'추가하다',
      search:'찾다',
      topPullText:'아래로 당겨 새로 고침',
      topDropText:'출시 새로고침',
      topLoadingText:'로딩 중...',
      copy_succ:'성공적으로 복사',
      copy_fail:'복사 실패',
      about:'About'
    },
    share:{
      title:'공유하다',
      download:'코드를 스캔하여 AuWallet 다운로드',
      sharecode:'초대 코드(복사하려면 클릭):',
      view_invites:'초대 세부정보 보기',
      copy_link:'링크 복사',
      attention:'위 링크를 복사하여 모바일 브라우저에 붙여넣고 열어서 Au 지갑을 다운로드 받으세요.'
    },
    wealth:{
      tit:"자산",
      title:'내 재산',
      title1:'채광',
      title2:'코인플랜',
      hot:'인기 추천',
      plan1:'주문형 요금제',
      plan2:'고정 계획',
      annu_return:'연간 수익',
      in_amount:'금액',
      transfer_all:'모두',
      view_rules:'규칙 보기',
      pay_password:'결제 비밀번호를 입력해주세요',
      asset:'재산',
      search:'거래조회',
      rules:'규칙',
      order_time:'주문 시간',
      value_date:'계약 날짜',
      expiry_date:'만료일',
      highlights:'하이라이트',
      remaining_quota:'남은 할당량',
      buy:'지금 구매',
      ystday_earnings:"어제의 수입",
      total_earnings:'전체 수익',
      transfer_in:'~에',
      transfer_out:'밖',
	  transfer_outed:'이미 되찾았다',
      tran_all:'모두',
      tran_in:'~에',
      tran_out:'밖',
      tran_earning:'수입을 얻다',
      prod_all:'모두',
      prod1:'PoS 마이닝',
      prod2:'코인플랜',
      curr_all:'모두',
      out_amount_tip:'이체 금액을 입력하세요.',
      send:'보내다',
      success:'성공',
      amount_tip:'금액을 입력하세요',
    },
    ads:{
      title:'좋은 소식',
      content:'U2U 가 급등하고 있습니다.',
      content2:'2UT 가 급등하고 있습니다.',
      buy:'구입',
      plan_name:'U2U 신주 발행',
      tip: 'U2U is 10% off!'
    },
    buyuut: {
      maxtip: 'Each person can buy a maximum of 100',
      current: 'Current',
      price: 'Price',
      discount: 'Discount',
      off: 'OFF',
      amountlabel: 'Purchase quantity',
      maxerror: 'You can\'t buy more than 100',
      totalprice: 'Total Price',
      balance: 'Balance',
      purchase: 'Purchase',
      rulestitle: 'Rules of Activity'
    },
	  receive:{
		  fuzhicg:'복사에 성공했습니다.',
		  fuzhicc:'복사에 실패했습니다.',
	  },
	  alert:{
	  	  cancel:'취소',
	  	  confirm:'확인'
	  },
  against:{
		  no100: 'USDT는 100의 배수여야 합니다.'
	},
	package:{
		  title: '소포',
		  amount: '수량',
		  time: '시간',
		  coin: '동전',
		  price: '가격',
		  scale: '규모',
		  quantity: '재다',
		  submit: '제출',
		  total: '전부',
		  points: '가리키다',
		  apoints2: '부의 가용 이익',
		  balance: '균형',
		  apoints: '사용 가능한 포인트:',
		  abalance: '사용 가능한 잔액 (USDT):',
		  abalance2: '사용 가능한 잔액 (U2U):',
		  import: '수입하다',
		  orders: '주문',
		  orders_detail: '주문 상세 정보',
		  defi: 'DEFI',
		  nopoint: '사용 가능한 포인트 이상 교환',
		  nobalance: '사용 가능한 잔액을 초과하여 상환하다.',
		  nologin: '로그인이 만료되었습니다. 다시 로그인하십시오.',
		  pay_type: '결제 유형'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
  }
  